function SubText({text}) {
    return (
        <p style={{margin: 0, color: "grey", fontSize: "small"}}>{text}</p>
    )
}

export default SubText;